var path = 'views/loading.html';
var html = "<div class=\"docketbookLoadingSpecial\">\n  <div class=\"lds-ring\"><div></div><div></div><div></div><div></div></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/views/loading.html
// module id = fGOF
// module chunks = 0